<a class="nav-link" (click)="toggle()" [ngClass]="{ active: isActive, collapsed: collapsed }">
	@if (sideNavItem?.icon) {
		<div class="nav-link-icon">
			@if (sideNavItem.awesome) {
				<fa-icon [icon]="iconProp"></fa-icon>
			} @else {
				<i-feather [name]="sideNavItem.icon"></i-feather>
			}
		</div>
	}
	{{ sideNavItem?.text }}
	@if (sideNavItem?.new) {
		<div class="badge bg-primary ms-2">New!</div>
	}
	@if (sideNavItem?.updated) {
		<div class="badge bg-primary-soft text-primary ms-auto">Updated</div>
	}
	@if (sideNavItem?.submenu) {
		<div class="sidenav-collapse-arrow">
			<fa-icon class="ms-auto" [icon]="['fas', 'angle-down']"></fa-icon>
		</div>
	}
</a>
<nav class="sidenav-menu-nested nav" #collapsibleSection [ngClass]="{ collapsed: collapsed }">
	@for (submenuItem of sideNavItem?.submenu; track submenuItem.text) {
		@if (submenuItem.active) {
			<sbpro-side-nav-item
				class="submenu"
				[sideNavItem]="submenuItem"
				[ngClass]="{ collapsed: collapsed }"
				[hierarchy]="hierarchyExtension"></sbpro-side-nav-item>
		}
	}
</nav>
